const TRUE_OPTION_VALUE = "1";
const FALSE_OPTION_VALUE = "0";

/**
 * Converts a `booleanOptions` select value ("1" / "0") into a boolean. Booleans pass through untouched so
 * models that were never edited in the form keep their persisted value.
 */
export function parseBooleanOptionValue(value: unknown): boolean | null {
  if (typeof value === "boolean") return value;
  if (value === TRUE_OPTION_VALUE) return true;
  if (value === FALSE_OPTION_VALUE) return false;
  return null;
}
